import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Typography } from '@material-ui/core'
import {
  Check as CheckIcon,
  Favorite as FavoriteIcon,
  FavoriteBorder as FavoriteBorderIcon
} from '@material-ui/icons'
import automovilismo from 'assets/img/automovilismo.jpg'
import biking from 'assets/img/biking.jpg'
import fbi from 'assets/img/fbi.jpg'
import kayak from 'assets/img/kayak.jpg'
import motocross from 'assets/img/motocross.jpg'
import mountainBike from 'assets/img/mountain-bike.jpg'
import natacion from 'assets/img/natacion.jpg'
import ocr from 'assets/img/ocr.jpg'
import running from 'assets/img/running.jpg'
import speedway from 'assets/img/speedway.jpg'
import trekking from 'assets/img/trekking.jpg'
import clsx from 'clsx'
import moment from 'moment'
import { EditableImage, ShareUrlMenuDialog } from 'shared'
import { verifyUserNotLogged } from 'state/modules/app'
import {
  deleteImage as deleteImageChampionship,
  react,
  setImage as updateImageChampionship
} from 'state/modules/championships'
import { CHAMPIONSHIP_TYPES } from 'utils/constants'

import { useStyles } from './Header.style'

const DISCIPLINE_IMAGES = {
  automovilismo,
  biking,
  fbi,
  kayak,
  motocross,
  mountainBike,
  natacion,
  running,
  speedway,
  trekking,
  ocr
}

const Header = ({ canEdit, altMode }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const { championship, pendingReact } = useSelector((state) => state.championships)
  const { user } = useSelector((state) => state.auth)

  const {
    name,
    profileImages,
    slugUrl,
    loggedUserMetadata,
    likesCount,
    id,
    createdAt,
    from,
    to,
    eventsCount,
    disputedEventsCount,
    computedEventsCount,
    disciplines,
    lastEventAccreditationRequired
  } = championship

  const fromLocal = moment(from)
  const toLocal = moment(to)

  const eventDateFormat = fromLocal.isSame(toLocal, 'years')
    ? fromLocal.format('YYYY')
    : `${fromLocal.format('YYYY')}/${toLocal.format('YYYY')}`

  const hasProfileImage = Array.isArray(profileImages) && profileImages.length > 0

  const getImageUrl = () => (hasProfileImage ? profileImages[0] : null)

  const handleSaveImage = ({ value }) => dispatch(updateImageChampionship(id, value))
  const handleDeleteImage = () => dispatch(deleteImageChampionship(championship))

  const handleActionChampionship = (action) => {
    if (!user) {
      dispatch(verifyUserNotLogged({ state: true }))
    } else {
      dispatch(action(championship))
    }
  }

  const renderActionButtons = () => (
    <div>
      <Button
        variant='outlined'
        color='primary'
        disabled={pendingReact}
        className={classes.actionButton}
        classes={{ label: classes.actionButtonLabel }}
        title={!loggedUserMetadata.like ? 'Me gusta' : 'Ya no me gusta'}
        onClick={() => handleActionChampionship(react)}>
        {loggedUserMetadata.like ? <FavoriteIcon /> : <FavoriteBorderIcon />}
        <em>{!!likesCount && likesCount}</em>
      </Button>
      <ShareUrlMenuDialog
        id={id}
        type='championship'
        isHiddenLabel
        isOutlineIcon
        updatedAt={createdAt}
        copyMessage='El link del evento fue copiado al portapapeles'
        slugUrl={slugUrl}
        title={name}
        buttonClassName={classes.shareButton}
      />
    </div>
  )

  const options = disciplines.map((x) => ({
    ...x,
    imgUrl: DISCIPLINE_IMAGES[x.imageName],
    className: clsx(x.imageName && classes[x.imageName])
  }))

  const type = Object.values(CHAMPIONSHIP_TYPES).find((x) => x.value === championship.type)

  return (
    <div className={clsx(classes.header, altMode && 'alt')}>
      <EditableImage
        entity={championship}
        mode='button'
        field='profileImages'
        canEdit={canEdit}
        defaultImage={getImageUrl()}
        className={classes.featureImageContainer}
        inputClassName={classes.featureImage}
        onSave={handleSaveImage}
        title='Portada del campeonato'
        onDelete={handleDeleteImage}
        defaultImageComponent={
          <>
            <div className={classes.imageInfoContainer}>
              <div className={classes.infoContainer}>
                <Typography color='primary' className={classes.infoTitle}>
                  Elegí una buena imagen de portada para que el campeonato se destaque.
                </Typography>
                <Typography color='primary' className={classes.infoText}>
                  Recordá:
                </Typography>
                <Typography color='primary' className={classes.infoText}>
                  <CheckIcon className={classes.checkIcon} /> Las dimensiones correctas son 827 x
                  403px.
                </Typography>
                <Typography color='primary' className={classes.infoText}>
                  <CheckIcon className={classes.checkIcon} /> El formato es horizontal.
                </Typography>
                <Typography color='primary' className={classes.infoText}>
                  <CheckIcon className={classes.checkIcon} /> Ubicá la información más relevante en
                  la mitad inferior de la imagen.
                </Typography>
                <Typography color='primary' className={classes.infoText}>
                  <CheckIcon className={classes.checkIcon} /> Tipo de archivos permitidos .jpg o
                  .jpeg.
                </Typography>
                <Typography color='primary' className={classes.infoText}>
                  <CheckIcon className={classes.checkIcon} /> Peso máximo 10MB.
                </Typography>
                <Typography color='primary' className={classes.infoText}>
                  *En caso de no seleccionar una imagen para el campeonato se mostrará esta imagen.
                </Typography>
              </div>
            </div>
            {options
              .filter((x) => !!x.imageName)
              .map((x) => (
                <div
                  key={x.id}
                  className={clsx(
                    classes.featureImage,
                    x.className,
                    `size-${options.filter((x) => !!x.imageName).length}`
                  )}
                  style={{ backgroundImage: `url(${x.imgUrl})` }}
                />
              ))}
          </>
        }>
        <div className={classes.featureImageContainer}>
          {hasProfileImage ? (
            <div
              className={classes.featureImage}
              style={{ backgroundImage: `url(${getImageUrl()})` }}
            />
          ) : (
            options
              .filter((x) => !!x.imageName)
              .map((x) => (
                <div
                  key={x.id}
                  className={clsx(
                    classes.featureImage,
                    x.className,
                    `size-${options.filter((x) => !!x.imageName).length}`
                  )}
                  style={{ backgroundImage: `url(${x.imgUrl})` }}
                />
              ))
          )}
        </div>
      </EditableImage>

      <div className={classes.panel}>
        <div className={classes.eventInfoContainer}>
          <div className={classes.date}>{eventDateFormat}</div>

          <EditableImage
            className={classes.featureImageContainerMobile}
            canEdit={canEdit}
            inputClassName={classes.featureImage}
            defaultImage={getImageUrl()}
            onSave={handleSaveImage}
            onDelete={handleDeleteImage}
            title='Portada del campeonato'
            entity={championship}
            defaultImageComponent={
              <>
                <div className={classes.imageInfoContainer}>
                  <div className={classes.infoContainer}>
                    <Typography color='primary' className={classes.infoTitle}>
                      Una buena imagen de portada destaca tu campeonato.
                    </Typography>

                    <Typography color='primary' className={classes.infoText}>
                      Dimensiones: 827 x 403px.
                    </Typography>
                    <Typography color='primary' className={classes.infoText}>
                      Formato es horizontal.
                    </Typography>

                    <Typography color='primary' className={classes.infoText}>
                      Tipo de archivos permitidos .jpg o .jpeg.
                    </Typography>
                    <Typography color='primary' className={classes.infoText}>
                      Peso máximo 10MB.
                    </Typography>
                    <Typography color='primary' className={clsx(classes.infoText, classes.endText)}>
                      *En caso de no seleccionar una imagen para el campeonato se mostrará esta
                      imagen.
                    </Typography>
                  </div>
                </div>

                {options
                  .filter((x) => !!x.imageName)
                  .map((x) => (
                    <div
                      key={x.id}
                      className={clsx(
                        classes.featureImage,
                        x.className,
                        `size-${options.filter((x) => !!x.imageName).length}`
                      )}
                      style={{ backgroundImage: `url(${x.imgUrl})` }}
                    />
                  ))}
              </>
            }
            field='profileImages'
            mode='button'>
            <div className={classes.featureImageContainerMobile}>
              {hasProfileImage ? (
                <div
                  className={classes.featureImage}
                  style={{ backgroundImage: `url(${getImageUrl()})` }}
                />
              ) : (
                options.map((x) => (
                  <div
                    key={x.id}
                    className={clsx(classes.featureImage, x.className, `size-${options.length}`)}
                    style={{ backgroundImage: `url(${x.imgUrl})` }}
                  />
                ))
              )}
            </div>
          </EditableImage>

          {renderActionButtons()}
        </div>
        <div className={classes.titleContainer}>
          <Typography
            variant='h2'
            className={clsx(classes.title, classes.eventName)}
            color='primary'>
            {name}
          </Typography>
          <Typography variant='h2' className={classes.title} color='primary'>
            Eventos disputados: {disputedEventsCount}/{eventsCount}
          </Typography>
          <Typography variant='h2' className={classes.title} color='primary'>
            Eventos computables: Los mejores {computedEventsCount}/{eventsCount}
          </Typography>
          <Typography variant='h2' className={classes.title} color='primary'>
            Ultimo evento obligatorio: {lastEventAccreditationRequired ? 'Si' : 'No'}
          </Typography>
          <Typography variant='h2' className={classes.title} color='primary'>
            Tipo: {type.label}
          </Typography>
        </div>

        <div style={{ flexGrow: 1 }}></div>
      </div>
    </div>
  )
}

export default Header
